import * as React from 'react'
import { IUploadGifComponentProps } from "./IUploadGifComponentProps";
import { IUploadGifComponentState } from "./IUploadGifComponentState";
import MagicDropzone from "react-magic-dropzone";
import { connect } from "react-redux";
import * as gifActions from 'src/actions/gifAction';
import Loader from 'react-loader-spinner'
import { WithContext as ReactTags } from 'react-tag-input';
import 'src/assets/css/tags.css';
import HeaderComponent from "src/components/homeHeader/HeaderComponent";
import MenuComponent from "src/components/menuComponent/MenuComponent";
import FooterComponent from "src/components/footerComponent/FooterComponent";
import icon2 from "../../assets/images/ion2.svg";
import { Grid } from 'semantic-ui-react'
import MenuLeftComponent from "../../App";
import { slide as Menu } from 'react-burger-menu'
import MenuLeftemobile from "../menuLeftMobile/MenuLeftemobile";
import * as modalActions from "../../actions/modalActions";
import * as action from "../../actions/toastAction";

class UploadGifComponent extends React.Component<IUploadGifComponentProps, IUploadGifComponentState> {

    constructor(Props: IUploadGifComponentProps) {
        super(Props)
        this.state = {
            value: ".gif",
            previews: [],
            title: '',
            description: '',
            tags: [],
            accepted : [],
            uploaded : false,
        }
    }
    KeyCodes = {
        comma: 188,
        enter: 13,
    };
    delimiters = [this.KeyCodes.comma, this.KeyCodes.enter];
    handleDelete = (i) => {
        const { tags } = this.state;
        this.setState({
            tags: tags.filter((tag, index) => index !== i),
        });
    }
    handleAddition  = (tag) => {
        tag.text = '#'+tag.text
        if(this.state.tags.filter(t => t.text === tag.text ) == 0)
            this.setState(state => ({ tags: [...state.tags, tag] }));
    }
    handleDrag = (tag, currPos, newPos) => {
        const tags = [...this.state.tags];
        const newTags = tags.slice();
        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);
        // re-render
        this.setState({ tags: newTags });
    }
    handleChange = () => {
        let title, description, tags: any;
        (() => {
            title = document.querySelector("#title");
        })();
        title = title.value
        this.setState({
            title: title,
        });
    }
    onRemove = () => {
        event.preventDefault()
        this.setState({
            previews: [],
            accepted: []
        })
    }
    onDrop = (accepted, rejected, links ) => {
        let newPreviews = [...this.state.previews, ...accepted.map(v => v.preview), ...links];
        if (this.state.accepted.length < 1  )
            this.setState({
                previews: newPreviews,
                accepted: accepted
                });
    };
    async onSubmit(){
       if (this.props.authenticated) {
       event.preventDefault()
       if (this.state.accepted[0]) {
            if (this.state.tags.length > 0){
                this.setState({uploaded : true})
                await this.props.handleSubmit(this.props.user,this.state.tags,this.state.title,this.state.description,this.state.accepted[0] ,null, (key)=>{
                this.props.history.push('/gif/'+key)
                this.setState({uploaded : false})
                })
            }else
            {
                this.props.showToast("Ajouter des tags", true, () => { })
            }
       }




       }
            else {

                this.props.openLoginModal(true , ()=>{})

       }


    }
    public render() {
        const isLoggedIn = this.props.authenticated ;
        return (
                <div>
                    <MenuLeftemobile/>
                    <HeaderComponent />
                    <MenuComponent/>
					<div
						style={{
							minHeight: 'calc(100vh - 235px)'
						}}
					>
						{
						!this.state.uploaded ?

								<Grid stackable /*style={{ marginBottom: '120px' }}*/ columns={2}>
									<Grid.Column textAlign="center">
										<MagicDropzone style={{
											height: 328,
											marginTop: 25,
											marginBottom: 0,
											width: '100%',
											background: 'linear-gradient(180deg, rgba(51, 114, 194, 0.8) 0%, rgba(243, 76, 113, 0.73) 100%)',
											maxWidth: '500px'
										}}
											className="Dropzone"
											accept={this.state.value}
											onDrop={this.onDrop}>
											<div className="Dropzone-content">
												{this.state.accepted.length > 0 ? (
													this.state.accepted.map((v, i) => (
														<div key={i} className="Dropzone-img-big">
															<div onClick={this.onRemove}
																style={{
																	float: 'right',
																	backgroundColor: '#999999',
																	color: 'white',
																	borderRadius: '40%',
																	padding: '5px',
																	opacity: 0.3
																}}>
																<p style={{ margin: '5px' }}>x</p>
															</div>
															<img alt="" src={v.preview} />
														</div>

													))
												) : (
														"Déposez quelques fichiers sur moi!"
													)}
											</div>
										</MagicDropzone>
									</Grid.Column>
									<Grid.Column >
										<div>
											<form style={{
												maxWidth: 500,
												height: 328,
												background: 'linear-gradient(180deg, rgba(51, 114, 194, 0.8) 0%, rgba(243, 76, 113, 0.73) 100%)',
												marginTop: '22px',
												marginLeft: 'auto',
												marginRight: 'auto'
											}}>
												<div style={{

													maxWidth: '472px',
													height: '35px',
													paddingLeft: '21px',
													marginTop: '25px'

												}}>
													<input
														style={{
															width: '98%',
															height: '100%',
															paddingLeft: '21px',
															marginTop: '20px'
														}}
														placeholder='Ajouter du texte à afficher sur le GIF' type="text" value={this.state.title} id='title'
														onChange={this.handleChange} />

												</div>
												<ReactTags
													tags={this.state.tags}
													handleDelete={this.handleDelete}
													handleAddition={this.handleAddition}
													handleDrag={this.handleDrag}
													delimiters={this.delimiters}
													inline={false}
                                                    placeholder={ 'Cliquez sur entrée pour ajouter un nouveau tag'}
													classNames={{
														remove: 'removeClass2',
														tagInput: 'inputTags',
														selected: 'selectedClass btn',
														tag: 'tagClass'
													}}
													style={{
														marginTop: '40px'
													}} />

												<div className="btn"

													style={{
														maxWidth: '80% ',
														paddingRight: '10px',
														paddingLeft: '21px',
														marginLeft: '45px',
														marginTop: '25px',
														cursor: 'pointer'
													}}
													onClick={() => this.onSubmit()}    >
													<div className="btnIcon"><img src={icon2} /></div>
													<div className="btninsideContainer">
														<div className="firstTitle">PUBLIER</div>
													</div>
												</div>
											</form>
										</div>
									</Grid.Column>
								</Grid>
								:
								<Loader type="Plane" color="#f34c71" height={80} width={80} />
						}
					</div>
				<FooterComponent />
			</div>

		)
	}
}
function mapsStateToProps(state) {
	return {
		errorMessage: state.auth.errorMessage,
		authenticated: state.auth.authenticated,
		user: state.auth.currentUser,
		newGif: state.Gif,
		openSide: state.toast.openSide,


    };
}
const mapDispatchToProps = (dispatch: any, ownProps: IUploadGifComponentProps) => {
	return {
		handleSubmit: (user, tags, title, description, file, text, cb) => dispatch(gifActions.onSubmit(user, tags, title, description, file, text, cb)),
        openLoginModal: (type , cb) => dispatch(modalActions.loginModal(type, cb)),
        showToast: (title, show, cb) => dispatch(action.toast(title, show, cb)),
    }
}
export default connect(mapsStateToProps, mapDispatchToProps)(UploadGifComponent)



// WEBPACK FOOTER //
// ./src/components/uploadGifComponent/UploadGifComponent.tsx